import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {GeneralService} from './general.service';
import {Injectable} from '@angular/core';
import * as _ from 'lodash';

@Injectable()
export class OrderHeadersService extends GeneralService {

    static STATUS_OPEN                            = 1;
    static STATUS_PARTIALLY_ACKNOWLEDGED          = 5;
    static STATUS_ACKNOWLEDGED                    = 10;
    static STATUS_PARTIALLY_CONFIRMED             = 15;
    static STATUS_CONFIRMED                       = 20;
    static STATUS_PARTIALLY_CONFIRMED_AND_CHANGED = 25;
    static STATUS_CONFIRMED_AND_CHANGED           = 30;
    static STATUS_PARTIALLY_SHIPPED               = 35;
    static STATUS_SHIPPED                         = 40;
    static STATUS_PARTIALLY_INVOICED              = 45;
    static STATUS_INVOICED                        = 50;
    static STATUS_CLOSED                          = 55;
    static STATUS_REJECTED                        = 100;

    constructor(protected http: HttpClient) {
        super(http);
    }

    public getItems(page): Observable<any> {
        const current_page = page.pageNumber + 1;
        let params = new HttpParams();
        params = params.append('perPage', page.size);
        params = params.append('page', current_page.toString());
        if (!_.isUndefined(page.sortParams)) {
            for (const key of Object.keys(page.sortParams)) {
                const value = page.sortParams[key];
                params = params.append('sort[]', key + ',' + value );
            }
        }
        if (!_.isUndefined(page.filterParams)) {
            for (const key of Object.keys(page.filterParams)) {
                const value = page.filterParams[key];
                if (value && value !== '') {
                    params = params.append(key, value);
                }
            }
        }
        return this.http.get(this.apiUrl + '/order-headers', { params : params });
    }

    getById(PO1_ID: number) {
        const url = `${this.apiUrl}/order-headers/${PO1_ID}`;
        return this.http.get(url)
            .catch(this.handleError);
    }

    /*
    getByPOId(id: number): Observable<IResponse<object>> {
        const url = `${this.apiUrl}/order-lines/show/${id}`;
        return this.http.get(url)
            .map(
                data => this.extractPayload(data)
            )
            .catch(this.handleError);
    }
    */

    getStatuses() {
        return [
            {value: null,                                                       text: 'All'},
            {value: OrderHeadersService.STATUS_OPEN,                            text: 'Open'},
            {value: OrderHeadersService.STATUS_PARTIALLY_ACKNOWLEDGED,          text: 'Partially Acknowledged'},
            {value: OrderHeadersService.STATUS_ACKNOWLEDGED,                    text: 'Acknowledged'},
            {value: OrderHeadersService.STATUS_PARTIALLY_CONFIRMED,             text: 'Partially Confirmed'},
            {value: OrderHeadersService.STATUS_CONFIRMED,                       text: 'Confirmed'},
            {value: OrderHeadersService.STATUS_PARTIALLY_CONFIRMED_AND_CHANGED, text: 'Partially Confirmed & Changed'},
            {value: OrderHeadersService.STATUS_CONFIRMED_AND_CHANGED,           text: 'Confirmed & Changed'},
            {value: OrderHeadersService.STATUS_PARTIALLY_SHIPPED,               text: 'Partially Shipped'},
            {value: OrderHeadersService.STATUS_SHIPPED,                         text: 'Shipped'},
            {value: OrderHeadersService.STATUS_PARTIALLY_INVOICED,              text: 'Partially Invoiced'},
            {value: OrderHeadersService.STATUS_INVOICED,                        text: 'Invoiced'},
            {value: OrderHeadersService.STATUS_CLOSED,                          text: 'Closed'},
            {value: OrderHeadersService.STATUS_REJECTED,                        text: 'Rejected'}
        ];
    }

    getStatistics(): Observable<object> {

        const url = `${this.apiUrl}/import-histories/statistics`;
        return this.http.get(url)
            .map(
                data => this.extractPayload(data)
            )
            .catch(this.handleError);
    }

    preloadData(): Observable<any> {
        return this.http.get(this.apiUrl + '/order-headers/preload');
    }

    export(columns, page, fileName): Observable<any> {
        const url = '/order-header/export?col=' + columns;
        return this.getXlsx(url, page, fileName);
    }

    confirmLines( PO1_ID, lines ) {
        const url = `${this.apiUrl}/order-headers/confirm-lines`;
          return this.http.post(url, {PO1_ID: PO1_ID, lines: JSON.stringify(lines)})
            .map(data => this.extractPayload(data))
            .catch(this.handleError);
    }

    rejectLines(PO1_ID, lines) {
        const url = `${this.apiUrl}/order-headers/reject-lines`;
        return this.http.post(url, {PO1_ID: PO1_ID, lines: JSON.stringify(lines)})
            .map(data => this.extractPayload(data))
            .catch(this.handleError);
    }

    shipLines(PO1_ID, lines) {
        const url = `${this.apiUrl}/order-headers/ship-lines`;
          return this.http.post(url, {PO1_ID: PO1_ID, lines: JSON.stringify(lines)})
            .map(data => this.extractPayload(data))
            .catch(this.handleError);
    }

    invoiceLines(PO1_ID, lines) {
        const url = `${this.apiUrl}/order-headers/invoice-lines`;
          return this.http.post(url, {PO1_ID: PO1_ID, lines: JSON.stringify(lines)})
            .map(data => this.extractPayload(data))
            .catch(this.handleError);
    }

    printPDF(page) {
        const url = `${this.apiUrl}/order-headers/print-pdf`;
        const defaultFileName = 'PurchaseOrder.pdf';
        return this.getPdf(url, defaultFileName, page);
    }

    resend(PO1_ID, extended: boolean = false) {
        const url = `${this.apiUrl}/order-headers/resend`;
          return this.http.post(url, {
              PO1_ID: PO1_ID,
              extended: extended
          }).catch(this.handleError);
    }

    public deleteMultiple(PO1_IDs) {
        return this.http.post(this.apiUrl + '/order-headers/delete-multiple', { PO1_IDs: PO1_IDs })
            .catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/services/order-headers.service.ts